<template>
  <span>{{ text }}</span>
</template>

<script>
import {formatGameTime} from '@/common/mlbbBroadcast'
import {CLOCK_TICK_MS, clockTarget, stepClock} from '@/common/mlbbOverlay'

/**
 * Игровой таймер эфира. Бэк присылает game_time раз в несколько секунд — между тиками
 * время идёт само, секунда за секундой, и плавно подстраивается под новые данные.
 * На паузе и вне фазы play стоит на значении с сервера.
 */
export default {
  name: 'MbGameTimer',
  props: {
    battle: {type: Object, required: true},
  },
  data() {
    return {anchor: null, shown: null, last: 0, timer: null}
  },
  computed: {
    running() {
      return this.battle.state === 'play' && !this.battle.paused
    },
    text() {
      return formatGameTime(this.shown === null ? this.battle.game_time : this.shown)
    },
  },
  watch: {
    'battle.id'() {
      this.shown = null
      this.reanchor()
    },
    // якорь переставляем только когда время на сервере сдвинулось: повторный тик с тем же
    // game_time не должен отбрасывать таймер назад
    'battle.game_time'() {
      this.reanchor()
    },
    running() {
      this.reanchor()
    },
  },
  created() {
    this.reanchor()
  },
  mounted() {
    this.last = Date.now()
    this.timer = setInterval(this.tick, CLOCK_TICK_MS)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    reanchor() {
      this.anchor = {gameTime: Number(this.battle.game_time) || 0, at: Date.now(), running: this.running}
      // вне игры (драфт, конец) показываем ровно то, что прислал сервер
      if (!this.running && this.battle.state !== 'play') this.shown = this.anchor.gameTime
      else this.tick()
    },
    tick() {
      const now = Date.now()
      const dt = now - (this.last || now)
      this.last = now
      this.shown = stepClock(this.shown, clockTarget(this.anchor, now), dt)
    },
  },
}
</script>
